import QueryString from "qs";
import { FC } from "react";
import { useTranslation } from 'react-i18next';
import { Helmet } from "react-helmet";
import { useHistory, useLocation } from "react-router-dom";
import Button from "../Button";

interface IProps {
  title: string|undefined;
}

const TutorHeader: FC<IProps> = ({
  title,
}) => {  
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <div className="content-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-6 flex">
              <h1 className="m-0">{title}</h1>
            </div>
            <div className="col-sm-6 comm-btn__area right">
              <Button
                className="btn-basic pink-line"
                onClick={() => history.push(`/?date=${query.date}`)}
                text={t('class.tutor.button1')}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TutorHeader;
